import * as React from 'react';
import '../css/displayLabelValue.sass';

interface FieldLabelProps {
  children: React.ReactNode;
}

export default function DisplayLabel(props: FieldLabelProps) {
  return <span className="displayLabel">{props.children}</span>;
}
